import { tokens } from "@/styles/tokens"

// Status configurations for different entities
export const statusConfig = {
  // Read-only document types, separate from lifecycle/payment status.
  financial_document_types: {
    issued_invoice: { label: 'Factură emisă', color: tokens.colors.info, order: 1, hidden: true },
    received_invoice: { label: 'Factură primită', color: '#7C3AED', order: 2, hidden: true },
    issued_credit_note: { label: 'Storno emis', color: tokens.colors.info, order: 3, hidden: true },
    received_credit_note: { label: 'Notă de credit primită', color: '#7C3AED', order: 4, hidden: true },
    bank_statement: { label: 'Extras · Încasări', color: '#0F766E', order: 5, hidden: true },
    bank_statement_outgoing: { label: 'Extras · Plăți', color: '#0F766E', order: 6, hidden: true },
    pos_statement: { label: 'Extras POS', color: '#0F766E', order: 7, hidden: true },
    reconciliation: { label: 'Document reconciliere', color: '#0F766E', order: 8, hidden: true },
  },
  purchase_invoice_payments: {
    paid: { label: 'Plătită', color: tokens.colors.success, order: 1, hidden: true },
    partial: { label: 'Plătită parțial', color: tokens.colors.warning, order: 2, hidden: true },
    awaiting_bank: { label: 'Așteaptă banca', color: tokens.colors.warning, order: 2, hidden: true },
    awaiting_documents: { label: 'Plată neconfirmată', color: tokens.colors.gray, order: 3, hidden: true },
  },
  quotes: {
    price_info: { 
      label: "Info preț", 
      color: tokens.colors.info,
      order: 1
    },
    price_info_added: {
      label: "Informare client",
      color: tokens.colors.primary,
      order: 2
    },
    // Ținut de agentul AI cât timp compune și trimite informarea. Statusul e
    // lock-ul: cererea nu e în coada nimănui cât stă aici. Convenția pentru
    // statusurile de bandă automată e `agent_<ce face agentul>`, câte unul per
    // tranziție, ca o bandă viitoare să nu refolosească același status.
    agent_informing_client: {
      label: "Agent: informare client",
      color: tokens.colors.info,
      order: 3,
      // Nealegibil manual: îl pune backend-ul la predare și tot el îl
      // eliberează la final. Un operator care ar parca aici o cerere n-ar
      // avea cine să o preia. Rămâne vizibil pe bulină și în pastila din
      // lista de cereri.
      hidden: true
    },
    // Ținut de agentul „Info preț" cât timp cercetează piesa (istoric, stoc,
    // cataloage) și răspunde clientului. Aceeași regulă: statusul e lock-ul,
    // îl pune și îl eliberează backend-ul, nealegibil manual.
    agent_price_info: {
      label: "Agent: info preț",
      color: tokens.colors.info,
      order: 3,
      hidden: true
    },
    in_progress: {
      label: "În curs",
      color: tokens.colors.yellow,
      order: 4
    },
    informed_not_available: {
      label: "Informat N/A",
      color: tokens.colors.secondary,
      order: 5
    },
    informed_available: {
      label: "Informat disponibil",
      color: tokens.colors.secondary,
      order: 6
    },
    waiting_customer_info: {
      label: "Așteptare info client",
      color: tokens.colors.warning,
      order: 7
    },
    customer_in_reception: {
      label: "Receptie",
      color: tokens.colors.yellow,
      order: 8
    },
    missed_calls: {
      label: "Apeluri pierdute",
      color: tokens.colors.error,
      order: 9
    },
    no_contact: {
      label: "Fără contact",
      color: tokens.colors.error,
      order: 10
    },
    cancelled: {
      label: "Anulat",
      color: tokens.colors.error,
      order: 11
    },
  },
  
  // Future entity statuses
  sales: {
    awaiting_buyer_confirmation: { label: "Confirmare client", color: tokens.colors.yellow, order: 1 },
    collecting: { label: "Colectare", color: tokens.colors.info, order: 2 },
    packing: { label: "Ambalare", color: tokens.colors.primary, order: 3 },
    ready_to_ship: { label: "Pregătit de expediere", color: tokens.colors.yellow, order: 6 },
    shipped: { label: "Expediat", color: tokens.colors.primary, order: 7 },
    delivered: { label: "Livrat", color: tokens.colors.success, order: 8 },
    completed: { label: "Finalizat", color: tokens.colors.success, order: 9 },
    on_hold: { label: "În așteptare", color: tokens.colors.secondary, order: 10 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 11 },
  },
  
  invoices: {
    // Gri, nu verde: „Creată” e starea neutră a documentului. Verdele rămâne
    // pentru bani confirmați („Reconciliat”, „Încasată”), ca să nu se confunde.
    created: { label: "Creată", color: tokens.colors.gray, order: 1 },
    reversed: { label: "Stornată", color: tokens.colors.error, order: 2 },
    draft: { label: "Ciornă", color: tokens.colors.gray, order: 3 },
    sent: { label: "Trimisă", color: tokens.colors.info, order: 4 },
    paid: { label: "Plătită", color: tokens.colors.success, order: 5 },
    overdue: { label: "Restantă", color: tokens.colors.error, order: 6 },
    cancelled: { label: "Anulată", color: tokens.colors.secondary, order: 7 },
  },

  // Achiziții VSU (vehicule scoase din uz): the lifecycle of a car we bought
  // for dismantling, from the draft with the papers to its closing.
  vsu: {
    draft: { label: "Draft", color: tokens.colors.gray, order: 1 },
    acquired: { label: "Documente emise", color: tokens.colors.success, order: 2 },
    dismantled: { label: "Dezmembrat", color: tokens.colors.info, order: 3 },
    closed: { label: "Închis", color: tokens.colors.secondary, order: 4 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 5 },
  },
  purchase_invoices: {
    imported: { label: "Importată", color: tokens.colors.success, order: 1 },
  },

  in_house_work_reports: {
    ready: { label: "Pregătit", color: tokens.colors.info, order: 1 },
    printed: { label: "Printat", color: tokens.colors.success, order: 2 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 3 },
  },
  
  shipments: {
    estimated: { label: "Estimat", color: tokens.colors.gray, order: 1 },
    // Use primary to distinguish created shipments from other states
    created: { label: "Creat", color: tokens.colors.primary, order: 2 },
    processing: { label: "Procesare", color: tokens.colors.info, order: 3 },
    shipped: { label: "Expediat", color: tokens.colors.primary, order: 4 },
    in_transit: { label: "În tranzit", color: tokens.colors.yellow, order: 5 },
    delivered: { label: "Livrat", color: tokens.colors.success, order: 6 },
    returned: { label: "Returnat", color: tokens.colors.error, order: 7 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 8 },
    rejected: { label: "Refuzat", color: tokens.colors.error, order: 9 },
  },

  agent_needs: {
    new: { label: "Nou", color: tokens.colors.info, order: 1 },
    planned: { label: "Planificat", color: tokens.colors.yellow, order: 2 },
    done: { label: "Rezolvat", color: tokens.colors.success, order: 3 },
    rejected: { label: "Anulat", color: tokens.colors.gray, order: 4 },
  },

  kran_tenders: {
    new: { label: "Nouă", color: tokens.colors.info, order: 1 },
    read: { label: "Citită", color: tokens.colors.gray, order: 2 },
    interesting: { label: "Interesantă", color: tokens.colors.yellow, order: 3 },
    bidding: { label: "Ofertăm", color: tokens.colors.warning, order: 4 },
    submitted: { label: "Depusă", color: tokens.colors.secondary, order: 5 },
    won: { label: "Câștigată", color: tokens.colors.success, order: 6 },
    lost: { label: "Pierdută", color: tokens.colors.error, order: 7 },
    ignored: { label: "Ignorată", color: tokens.colors.gray, order: 8 },
  },

  inventory_jobs: {
    draft: { label: "Draft", color: tokens.colors.gray, order: 1 },
    in_progress: { label: "În lucru", color: tokens.colors.info, order: 2 },
    in_review: { label: "În verificare", color: tokens.colors.yellow, order: 3 },
    completed: { label: "Confirmat", color: tokens.colors.success, order: 4 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 5 },
  },

  inventory_items: {
    unknown_sku: { label: 'SKU necunoscut', color: tokens.colors.error, order: 1 },
    wrong_warehouse: { label: 'Alt depozit', color: tokens.colors.error, order: 2 },
    location_mismatch: { label: 'Locație diferită', color: tokens.colors.warning, order: 3 },
    whitespace_issue: { label: 'Eroare spațiu', color: tokens.colors.warning, order: 4 },
    unexpected: { label: 'Neașteptat', color: tokens.colors.warning, order: 5 },
    not_scanned: { label: 'Nescanat', color: tokens.colors.gray, order: 6 },
    partial: { label: 'Parțial', color: tokens.colors.yellow, order: 7 },
    ok: { label: 'OK', color: tokens.colors.success, order: 8 },
    over: { label: 'Peste', color: tokens.colors.error, order: 9 },
  },

  // Optional: Romanian labels for package types (UI usage)
  package_types: {
    1: { label: "Cutie / Colet" },
    2: { label: "Palet" },
    3: { label: "Plic" },
  },
  
  tasks: {
    new: { label: "Nou", color: tokens.colors.gray, order: 1 },
    // assigned: { label: "Atribuit", color: tokens.colors.primary, order: 2 },
    in_progress: { label: "În curs", color: tokens.colors.info, order: 3 },
    // blocked: { label: "Blocat", color: tokens.colors.yellow, order: 4 },
    completed: { label: "Finalizat", color: tokens.colors.success, order: 5 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 6 },
  },

  returns: {
    new: { label: "Nou", color: tokens.colors.gray, order: 1 },
    awaiting_verification: { label: "În verificare", color: tokens.colors.yellow, order: 2 },
    awaiting_refund: { label: "În curs de rambursare", color: tokens.colors.primary, order: 3 },
    in_progress: { label: "Procesare", color: tokens.colors.info, order: 4 },
    completed: { label: "Finalizat", color: tokens.colors.success, order: 5 },
    cancelled: { label: "Anulat", color: tokens.colors.error, order: 6 },
  },

  kran_contracts: {
    pending_signature: { label: "Așteptare semnătură",   color: tokens.colors.gray,     order: 1 },
    active:            { label: "Activ",                 color: tokens.colors.success,  order: 2 },
    completed:         { label: "Finalizat",             color: tokens.colors.info,     order: 3 },
    cancelled:         { label: "Anulat",                color: tokens.colors.error,    order: 4 },
  },

  kran_estimates: {
    active:            { label: "Activ",                 color: tokens.colors.success,  order: 1 },
    completed:         { label: "Finalizat",             color: tokens.colors.info,     order: 2 },
    cancelled:         { label: "Anulat",                color: tokens.colors.error,    order: 3 },
  },

  kran_contract_documents: {
    draft:             { label: "Draft",                 color: tokens.colors.gray,     order: 1 },
    generated:         { label: "Generat",               color: tokens.colors.success,  order: 2 },
    signed:            { label: "Semnat",                color: tokens.colors.info,     order: 3 },
    cancelled:         { label: "Anulat",                color: tokens.colors.error,    order: 4 },
  },

  // Statuses for line item history
  historical: {
    in_stock: { label: "În stoc", color: tokens.colors.success, order: 1 },
    not_available: { label: "Fără stoc", color: tokens.colors.error, order: 2 },
    unknown: { label: "Necunoscut", color: tokens.colors.warning, order: 3 },
    // Client-side empty states, based on requests before the current item.
    no_response: { label: "Fără răspuns", color: tokens.colors.gray, order: 4 },
    no_previous_requests: { label: "Fără cereri anterioare", color: tokens.colors.gray, order: 5 },
  },

  payments: {
    estimated: { label: "Estimată", color: tokens.colors.gray, order: 1 },
    emitted: { label: "Emisă", color: tokens.colors.yellow, order: 2 },
    gateway_confirmed: { label: "Confirmată de procesator", color: tokens.colors.info, order: 3 },
    reimbursed: { label: "Rambursată", color: tokens.colors.secondary, order: 5 },
    // Banii au fost retrași de bancă după o dispută pierdută pe card. Din
    // 09.09.2026 stă pe un rând de restituire propriu (vezi payment_refund_rows);
    // pe o încasare e forma veche, până o desparte migrarea. Factura trebuie
    // stornată, nu reemisă.
    charged_back: { label: "Chargeback", color: tokens.colors.error, order: 6 },
    cancelled: { label: "Anulată", color: tokens.colors.secondary, order: 7 },
    error: { label: "Eroare", color: tokens.colors.error, order: 8 },
    // Spargerea lui `paid`, release A. Direcția banilor vine din scopul plății,
    // nu din status: pe vânzare și pe contract Kran banii intră („Încasată"), pe
    // retur ies („Achitată"). Etichetele există de pe acum ca o bulină să nu
    // afișeze valoarea brută în engleză dacă frontend-ul ajunge în producție
    // înaintea migrării datelor.
    collected: { label: "Încasată", color: tokens.colors.success, order: 4 },
    disbursed: { label: "Achitată", color: tokens.colors.success, order: 5 },
  },

  // Aceleași statusuri ca la `payments`, spuse din partea rambursării. Un rând de
  // rambursare pe o vânzare (`isRefundRow`) poartă exact aceeași listă ca o
  // încasare, dar înseamnă opusul: „Emisă” pe o încasare = bani așteptați, pe o
  // rambursare = bani plecați de la noi, doar că procesatorul n-a confirmat încă.
  // Fără vocabularul ăsta cele două rânduri arată identic pe ecran și nimeni nu
  // mai știe ce e fiecare. Toate `hidden`: se afișează, nu se aleg din dropdown.
  payment_refund_rows: {
    estimated: { label: "Rambursare estimată", color: tokens.colors.gray, order: 1, hidden: true },
    emitted: { label: "Rambursare în curs", color: tokens.colors.warning, order: 2, hidden: true },
    reimbursed: { label: "Rambursată", color: tokens.colors.secondary, order: 3, hidden: true },
    disbursed: { label: "Rambursată", color: tokens.colors.secondary, order: 4, hidden: true },
    cancelled: { label: "Rambursare anulată", color: tokens.colors.secondary, order: 5, hidden: true },
    error: { label: "Rambursare eșuată", color: tokens.colors.error, order: 6, hidden: true },
    // Rândul de restituire scris de bancă: dispută pierdută, banii retrași.
    // Factura trebuie stornată, nu reemisă.
    charged_back: { label: "Chargeback", color: tokens.colors.error, order: 7, hidden: true },
  },

  payment_reconciliation_matches: {
    no_match: { label: "Fără potrivire", color: tokens.colors.gray, order: 1 },
    suggested: { label: "Sugerat", color: tokens.colors.warning, order: 2 },
    // Calculat de backend: potrivirile confirmate acoperă doar o parte din
    // suma liniei. Se afișează, nu se alege — linia devine „Confirmat” doar
    // când facturile scrise pe ea acoperă toată încasarea.
    partial: { label: "Parțial", color: tokens.colors.warning, order: 3, hidden: true },
    confirmed: { label: "Confirmat", color: tokens.colors.success, order: 4 },
    rejected: { label: "Respins", color: tokens.colors.error, order: 5 },
    // Calculat de backend: potrivirile confirmate depășesc suma liniei — o
    // neconcordanță de verificat, nu „Confirmat”.
    over_allocated: { label: "Supra-alocat", color: tokens.colors.error, order: 6, hidden: true },
  },

  // Starea unei facturi față de bancă, calculată de backend
  // (invoices.reconciliation_state). Se afișează, nu se alege — de aceea toate
  // sunt `hidden`. Aici ca să arate identic pe factură, pe contract, pe companie
  // și în registru, prin StatusBadge.
  invoice_reconciliation: {
    reconciled: { label: "Reconciliat", color: tokens.colors.success, order: 1, hidden: true },
    partial: { label: "Parțial reconciliat", color: tokens.colors.warning, order: 2, hidden: true },
    // Banca a confirmat mai mult decât creanțele facturii: aceiași bani
    // înregistrați de două ori undeva.
    mismatch: { label: "Neconcordanță", color: tokens.colors.error, order: 2, hidden: true },
    // `pending` din backend, despărțit în registru după ce așteptăm de fapt:
    // banii de la client, decontarea curierului (ramburs), sau doar extrasul
    // băncii pentru bani deja încasați.
    pending: { label: "Așteaptă banca", color: tokens.colors.gray, order: 3, hidden: true },
    awaiting_payment: { label: "Așteaptă plata", color: tokens.colors.gray, order: 3, hidden: true },
    awaiting_settlement: { label: "Așteaptă decontarea", color: tokens.colors.gray, order: 3, hidden: true },
    awaiting_refund: { label: "Așteaptă rambursarea", color: tokens.colors.gray, order: 3, hidden: true },
    unreconciled: { label: "Nereconciliat", color: tokens.colors.error, order: 4, hidden: true },
    not_applicable: { label: "Nu se aplică", color: tokens.colors.gray, order: 5, hidden: true },
    not_tracked: { label: "Nu se urmărește", color: tokens.colors.gray, order: 6, hidden: true },
    // Nu sunt stări ale backendului: registrul desparte `not_applicable` după
    // plăți, ca rândul să spună DE CE nu are ce reconcilia.
    cash: { label: "Numerar", color: tokens.colors.gray, order: 7, hidden: true },
    cash_refund: { label: "Rambursat numerar", color: tokens.colors.gray, order: 8, hidden: true },
    no_payments: { label: "Fără plată", color: tokens.colors.gray, order: 9, hidden: true },
    no_refund: { label: "Fără rambursare", color: tokens.colors.gray, order: 9, hidden: true },
    // `accounting_closed_on`: scadențarul contabilei o are închisă, stoc nu are plata.
    accounting_closed: { label: "Închisă la contabilitate", color: tokens.colors.gray, order: 10, hidden: true },
  },

  // e-Factura state of an in-house document (invoices.spv_status and each
  // attempt's status). SmartBill rows have none: SmartBill submits those itself.
  invoice_spv: {
    scheduled: { label: "Netransmisă", color: tokens.colors.gray, order: 1, hidden: true },
    deferred: { label: "Amânată", color: tokens.colors.warning, order: 2, hidden: true },
    submitting: { label: "Se transmite", color: tokens.colors.info, order: 3, hidden: true },
    processing: { label: "În curs la ANAF", color: tokens.colors.info, order: 4, hidden: true },
    accepted: { label: "Acceptată", color: tokens.colors.success, order: 5, hidden: true },
    rejected: { label: "Respinsă", color: tokens.colors.error, order: 6, hidden: true },
    error: { label: "Eroare XML", color: tokens.colors.error, order: 7, hidden: true },
    unknown: { label: "Necunoscut", color: tokens.colors.warning, order: 8, hidden: true },
    not_required: { label: "Nu se transmite", color: tokens.colors.gray, order: 9, hidden: true },
    cancelled: { label: "Anulată", color: tokens.colors.secondary, order: 10, hidden: true },
  },

  // Bonuri cheltuieli: `registered` e bonul scris; celelalte sunt pozele
  // încărcate pe care AI-ul încă le citește sau le-a lăsat unui om.
  expense_receipts: {
    awaiting_pages: { label: "Așteaptă pagini", color: tokens.colors.info, order: 3, hidden: true },
    pending: { label: "În așteptare", color: tokens.colors.gray, order: 1, hidden: true },
    processing: { label: "Se citește", color: tokens.colors.info, order: 2, hidden: true },
    review: { label: "De completat", color: tokens.colors.warning, order: 3, hidden: true },
    failed: { label: "Nu s-a putut citi", color: tokens.colors.error, order: 4, hidden: true },
    registered: { label: "Înregistrat", color: tokens.colors.success, order: 5, hidden: true },
  },

  // Agricultură: an APIA rule on the crop diversification page.
  agro_rules: {
    met: { label: "Îndeplinită", color: tokens.colors.primary, order: 1 },
    not_met: { label: "Neîndeplinită", color: tokens.colors.error, order: 2 },
    exempt: { label: "Nu se aplică", color: tokens.colors.gray, order: 3 },
    manual: { label: "De verificat", color: tokens.colors.warning, order: 4 },
  },

  payment_reconciliation_documents: {
    classified: { label: "Clasificat", color: tokens.colors.info, order: 1 },
    awaiting_documents: { label: "Așteaptă documente", color: tokens.colors.secondary, order: 3 },
    unclassified: { label: "Neclasificat", color: tokens.colors.secondary, order: 4 },
    fully_matched: { label: "Potrivit complet", color: tokens.colors.success, order: 1 },
    needs_review: { label: "Necesită verificare", color: tokens.colors.warning, order: 2 },
  },

  // Employees (HR) statuses
  employees: {
    active: { label: "Activ", color: tokens.colors.success, order: 1 },
    suspended: { label: "Suspendat", color: tokens.colors.secondary, order: 2 },
    on_leave: { label: "Concediu", color: tokens.colors.yellow, order: 3 },
    terminated: { label: "Terminat", color: tokens.colors.error, order: 4 },
  },

  // Fleet maintenance statuses (work orders + alerts)
  fleet_maintenance: {
    scheduled: { label: "Programat", color: tokens.colors.info, order: 1 },
    in_progress: { label: "În lucru", color: tokens.colors.yellow, order: 2 },
    completed: { label: "Finalizat", color: tokens.colors.success, order: 3 },
    cancelled: { label: "Anulat", color: tokens.colors.gray, order: 4 },
    overdue: { label: "Depășit", color: tokens.colors.error, order: 5 },
    upcoming: { label: "Apropiat", color: tokens.colors.warning, order: 6 },
  },

  // Fleet vehicle statuses
  fleet: {
    active: { label: "Activ", color: tokens.colors.success, order: 1 },
    inactive: { label: "Inactiv", color: tokens.colors.gray, order: 2 },
    sold: { label: "Vândut", color: tokens.colors.info, order: 3 },
    scrapped: { label: "Casat", color: tokens.colors.error, order: 4 },
  },

  // User account statuses
  users: {
    1: { label: "Activ", color: tokens.colors.success, order: 1 },
    2: { label: "Inactiv", color: tokens.colors.gray, order: 2 },
    3: { label: "Șters", color: tokens.colors.error, order: 3 },
  },
};

// Helper function to get status options for an entity type
export const getStatusOptions = (entityType) => {
  const configs = statusConfig[entityType];
  if (!configs) return [];
  
  return Object.entries(configs)
    // `hidden` = statusul e recunoscut la citire (bulina îl afișează prin
    // getStatusConfig) dar nu poate fi ales de un operator. Vezi statusurile
    // `payments` de mai sus.
    .filter(([, config]) => !config.hidden)
    .map(([key, config]) => ({
      value: key,
      ...config
    }))
    .sort((a, b) => a.order - b.order);
};

// Helper function to get a specific status config
export const getStatusConfig = (entityType, status) => {
  return statusConfig[entityType]?.[status] || {
    label: status,
    color: tokens.colors.gray
  };
}; 

// ================= Currency Helpers =================
// Map numeric currency_id to code
export const currencyIdToCode = (id) => {
  const map = { 1: 'RON', 2: 'USD', 3: 'EUR' };
  return map?.[Number(id)] || 'RON';
};

// Map code to currency_id (fallback to 1)
export const currencyCodeToId = (code) => {
  const map = { RON: 1, USD: 2, EUR: 3 };
  return map?.[(code || '').toUpperCase()] || 1;
};
